import styled from "@emotion/styled/macro";

export const FoodDot = styled.div`
  position: absolute;
  width: 4%;
  height: 4%;
  background-color: #FF751D;
  border: 1px solid #fff;
  z-index: 1;
`;
